module.exports = __webpack_public_path__ + "static/img/hero-video-poster.267760b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/homepage/images/hero-video-poster.jpg
// module id = 5XeE
// module chunks = 1